(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvIconSelector', drvIconSelector);

    drvIconSelector.$inject = [];
    drvIconSelectorCtrl.$inject = ['SystemService'];

    /**
     * Control for selecting an SVG icon.
     *
     * # Scope Properties
     * @param {string} label - Label to be shown for the icon selector.
     * @param {string} selectedIcon - Name of the selected SVG icon.
     * @param {bool} readOnly - Flag for read only mode.
     * @param {bool} mandatory - Flag mandatory mode, where at least one value is required.
     */
    function drvIconSelector() {
        var directive = {
            restrict: 'E',
            scope: {},
            controller: drvIconSelectorCtrl,
            controllerAs: 'drvCtrl',
            bindToController: {
                label: '@?',
                selectedIcon: '=',
                readOnly: '<?',
                mandatory: '<?'
            },
            template:
            '<drv-selector value="drvCtrl.selectedIcon"' +
            '              items="drvCtrl.icons"' +
            '              label="{{drvCtrl.label}}"' +
            '              place-holder="Select an icon ..."' +
            '              disabled="drvCtrl.readOnly"' +
            '              ng-required="drvCtrl.mandatory">' +
            '   <selected-template>' +
            '       <drv-icon icon="item"></drv-icon> {{item}}' +
            '   </selected-template>' +
            '   <dropdown-item-template>' +
            '       <drv-icon icon="item"></drv-icon> {{item}}' +
            '   </dropdown-item-template>' +
            '</drv-selector>'
        };
        return directive;
    }

    function drvIconSelectorCtrl(SystemService) {
        /* jshint validthis:true */
        var drvCtrl = this;
        drvCtrl.icons = SystemService.getSVGIconList();
    }
})();